import { hasPermission } from '@/utils/permissions';

export const useHasPermission = (
  permissionNames: string[],
  availablePermissions: string[],
  isSuperAdmin?: boolean
): { isAllowed: boolean } => {
  return {
    isAllowed: hasPermission(
      permissionNames,
      availablePermissions,
      isSuperAdmin
    ),
  };
};
